import { Link } from 'react-router-dom';

function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#fbfbf9] text-neutral-950">
      <a
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-xl focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:shadow"
        href="#main"
      >
        Skip to content
      </a>

      <header className="border-b border-black/10 bg-white/70 backdrop-blur">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-6 py-4">
          <Link to="/" className="text-lg font-semibold tracking-tight">
            VolunteerCo
          </Link>
          <nav aria-label="Primary">
            <Link to="/" className="text-sm font-medium text-neutral-800 hover:text-neutral-950">
              Back to home
            </Link>
          </nav>
        </div>
      </header>

      <main id="main" className="mx-auto w-full max-w-3xl px-6 py-12">
        <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">Privacy</h1>
        <p className="mt-3 text-sm text-neutral-700">Last updated: 15 October 2026</p>

        <div className="mt-8 space-y-8 text-neutral-900">
          <p className="text-base leading-relaxed text-neutral-800">
            This privacy notice explains how VolunteerCo collects and uses your personal information when you
            register your interest on our website.
          </p>

          <section aria-labelledby="privacy-who">
            <h2 id="privacy-who" className="text-xl font-semibold tracking-tight">
              Who we are
            </h2>
            <p className="mt-2 leading-relaxed text-neutral-800">
              VolunteerCo operates in Australia. If you have questions or would like to access or correct
              your information, email{' '}
              <a className="font-medium underline underline-offset-4" href="mailto:silas@volunteer-co.com">
                silas@volunteer-co.com
              </a>
              .
            </p>
          </section>

          <section aria-labelledby="privacy-collect">
            <h2 id="privacy-collect" className="text-xl font-semibold tracking-tight">
              What we collect
            </h2>
            <p className="mt-2 leading-relaxed text-neutral-800">
              When you register your interest, we may collect:
            </p>
            <ul className="mt-3 list-disc space-y-1 pl-5 text-neutral-800">
              <li>Your name</li>
              <li>Your email address</li>
              <li>Your mobile number (if you provide it)</li>
              <li>
                Basic details about your organisation (for example: organisation name, your role, location,
                and community focus)
              </li>
              <li>Whether you’re registering as a volunteer or on behalf of an organisation</li>
            </ul>
          </section>

          <section aria-labelledby="privacy-why">
            <h2 id="privacy-why" className="text-xl font-semibold tracking-tight">
              Why we collect it
            </h2>
            <p className="mt-2 leading-relaxed text-neutral-800">We use this information to:</p>
            <ul className="mt-3 list-disc space-y-1 pl-5 text-neutral-800">
              <li>Contact you about VolunteerCo</li>
              <li>Understand interest in VolunteerCo, including where it may be most useful</li>
              <li>Improve the way we set up and support volunteer roles with clubs and community groups</li>
            </ul>
          </section>

          <section aria-labelledby="privacy-protect">
            <h2 id="privacy-protect" className="text-xl font-semibold tracking-tight">
              How we store and protect information
            </h2>
            <p className="mt-2 leading-relaxed text-neutral-800">
              We take reasonable steps to protect the personal information we hold from misuse, interference
              and loss, and from unauthorised access, modification or disclosure.
            </p>
          </section>

          <section aria-labelledby="privacy-share">
            <h2 id="privacy-share" className="text-xl font-semibold tracking-tight">
              When we share information
            </h2>
            <p className="mt-2 leading-relaxed text-neutral-800">
              We don’t sell your personal information. We only share it if we need to run VolunteerCo (for
              example, using secure service providers to store form submissions) or if we’re required by law.
            </p>
          </section>

          <section aria-labelledby="privacy-access">
            <h2 id="privacy-access" className="text-xl font-semibold tracking-tight">
              Access and correction
            </h2>
            <p className="mt-2 leading-relaxed text-neutral-800">
              You can request access to the personal information we hold about you, and request corrections,
              by emailing{' '}
              <a className="font-medium underline underline-offset-4" href="mailto:silas@volunteer-co.com">
                silas@volunteer-co.com
              </a>
              .
            </p>
          </section>

          <section aria-labelledby="privacy-complaints">
            <h2 id="privacy-complaints" className="text-xl font-semibold tracking-tight">
              Complaints
            </h2>
            <p className="mt-2 leading-relaxed text-neutral-800">
              If you have a concern about privacy, please email us and we’ll do our best to resolve it. You
              can also contact the Office of the Australian Information Commissioner (OAIC).
            </p>
          </section>

          <section aria-labelledby="privacy-changes">
            <h2 id="privacy-changes" className="text-xl font-semibold tracking-tight">
              Changes
            </h2>
            <p className="mt-2 leading-relaxed text-neutral-800">
              We may update this notice from time to time. The latest version will always be available on
              this page.
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-black/10 bg-white/70">
        <div className="mx-auto w-full max-w-6xl px-6 py-6 text-sm text-neutral-700">
          VolunteerCo · Australia · <a href="mailto:silas@volunteer-co.com">silas@volunteer-co.com</a>
        </div>
      </footer>
    </div>
  );
}

export default PrivacyPage;

